import * as dd from "dingtalk-jsapi";
import workService from "@/apis/work/index.js";
import { setStorageExpire, getStorageExpire } from "@/utils/utils";
import { Message } from "element-ui";

let ddUserInfo = null;

function setWebfunnyMonitor(userInfo) {
  if (window.WebfunnyMonitor) {
    // eslint-disable-next-line no-undef
    WebfunnyMonitor.initUser({
      userId: userInfo.user_id,
      userTag: userInfo.user_name,
    });
  }
}

export default function getUserInfo() {
  const ddUserInfoKey = "dd-user-info";
  return new Promise((resolve) => {
    const isDev = localStorage.getItem("liupl");
    const isChenmy = localStorage.getItem("chenmy");
    // const isDev = true;
    // ddUserInfo = getStorageExpire(ddUserInfoKey);
    // ddUserInfo = null;

    const ddUserId = getStorageExpire("dd-user-id");

    // if (dd.env.platform === "notInDingTalk" && isDev) {
    if (isChenmy) {
      // 我的开发环境
      resolve({
        // ding_user_id: "195850221221493570",
        ding_user_id: "265964585429592802",

        email: "penglong.liu@circleharmonyhealth.com",
        mobile: "15638945569",
        position: "前端开发工程师",
        // user_id: "195850221221493570",
        // 刘莉莉
        user_id: "b1ce0a543f932edf60dcd916d61ee2cc",
        user_name: "刘鹏龙",
      });
    } else if (isDev) {
      // 我的开发环境
      resolve({
        ding_user_id: "265964585429592802",
        // ding_user_id: "314652234838184207",

        email: "penglong.liu@circleharmonyhealth.com",
        mobile: "15638945569",
        position: "前端开发工程师",
        user_id: "265964585429592802",
        // 刘莉莉
        // user_id: "314652234838184207",
        user_name: "陈铭严",
      });
    } else if (ddUserInfo) {
      setWebfunnyMonitor(ddUserInfo);
      resolve(ddUserInfo);
    } else if (dd.env.platform !== "notInDingTalk") {
      dd.ready(() => {
        // dd.ready参数为回调函数，在环境准备就绪时触发，jsapi的调用需要保证在该回调函数触发后调用，否则无效。
        dd.runtime.permission.requestAuthCode({
          corpId: "ding2392b0260c57e24f35c2f4657eb6378f",
          onSuccess: (result) => {
            /*{
                code: 'hYLK98jkf0m' //string authCode
            }*/
            workService
              .getWorkDingAuth(result)
              .then((res) => {
                setStorageExpire(ddUserInfoKey, res, 60 * 24 * 7);
                ddUserInfo = res;
                setWebfunnyMonitor(ddUserInfo);
                resolve(res);
              })
              .catch(() => {
                Message({
                  message: "获取用户信息失败，请刷新页面",
                  type: "error",
                });
              });
          },
          onFail: function () {
            // reject(err)
            resolve({});

            Message({
              message: "获取用户信息失败，请刷新页面",
              type: "error",
            });
          },
        });
      });
    } else if (ddUserId) {
      const params = {
        ding_user_id: ddUserId,
      };
      workService.workUserGet(params).then((res) => {
        ddUserInfo = {
          ...res,
          ding_user_id: res.DingUserId,
          mobile: res.UserPhone,
          position: res.UserPosition,
          user_id: res.UserId,
          user_name: res.UserName,
        };
        setStorageExpire(ddUserInfoKey, ddUserInfo, 60 * 24 * 7);
        setWebfunnyMonitor(ddUserInfo);
        resolve(ddUserInfo);
      });
    } else {
      ddUserInfo = null;
      resolve(ddUserInfo);
    }
  });
}
